module.exports = __webpack_public_path__ + "media/images/choose-b5a7ebddb2eb6d6162d1be6a74e2c2e2.png";